import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const OtherServiceOfferings = lazy(
  () => import('@pages/landing/OtherServiceOfferings'),
);

export const OtherServiceOfferingsRoutes: RouteObject[] = [
  {
    path: '/other-service-offerings',
    element: (
      <React.Suspense>
        <OtherServiceOfferings />
      </React.Suspense>
    ),
  },
];
